<div class="grid-container">
    <p-panel *ngFor="let cat of _Utils.getOwnPropertyNames(appNames)" class="full-height" [header]="cat">
        <div class="flex-col gap-2">
            <p-button *ngFor="let appName of appNames[cat]" class="" [label]="appName" icon="fas fa-rim" styleClass="width100p" (onClick)="start(appName)"></p-button>
        </div>
    </p-panel>
</div>
